module.exports = __webpack_public_path__ + "static/media/email.83cd95bd.svg";